import React from "react";
import PropTypes from "prop-types";

const Filterbars = (props) => {
  return (
    <svg {...props} width="18" height="12" viewBox="0 0 18 12">
      <path
        id="_Color"
        data-name=" ↳Color"
        d="M11,12H7V10h4v2Zm4-5H3V5H15V7Zm3-5H0V0H18V2Z"

      />
    </svg>
  );
};

Filterbars.propTypes = {
  props: PropTypes.any,
};

export default Filterbars;
